import { RouteActionTypes } from '../../types/route';

export const setRoute = (payload: string) => {
    return { type: RouteActionTypes.ROUTE_CHANGE, payload };
};